import React, { useState, useEffect, useRef } from 'react';
import FlyUpModal from '../FlyUpModal';
import { getFontStylesAsync } from '../../../../utils/StoreConfigManager';
import './ImageCarouselModal.css';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import ModalOverlay from '../ModalOverlay';
import { StaticImage } from 'web-store-modules/packages/modal-media';
import { AppContext } from '../../../../AppContext';
import { CarouselArrowClicked } from '../../../../utils/Analytics';
import { constructUrl } from '../../../../utils/UrlConstructor';
import { Button } from 'web-store-modules/packages/web-store-ui-library';

const isMobile = isMobileDevice();
const rightArrow = 'https://obsessvr-webstore-assets-public.s3.amazonaws.com/fendi/right-arrow.svg';
const leftArrow = 'https://obsessvr-webstore-assets-public.s3.amazonaws.com/fendi/left-arrow.svg';
const closeIcon = 'https://cdn.obsess-vr.com/dyson/close-icon-v2.png';

const ImageCarouselModal = ({ modalContent, onModalHidden, currentSceneName, hotspotId }) => {
    const { pages } = modalContent;
    const [fontStyles, setFontStyles] = useState();
    const modalRef = useRef();
    const [carouselWidth, setCarouselWidth] = useState();
    const [distOffset, setDistOffset] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [xTranslation, setXTranslation] = useState(0);
    const carouselContainer = useRef();
    const totalItems = pages.length;

    useEffect(() => {
        fetchFontStyles();
        addListeners();
        return (() => {
            removeListeners();
        });
    }, []);

    useEffect(() => {
        if (carouselContainer.current && carouselContainer.current.clientWidth)
            setCarouselWidth(carouselContainer.current.clientWidth);
    }, [carouselContainer.current]);

    useEffect(() => {
        setDistOffset(carouselWidth * currentIndex);
    }, [currentIndex, carouselWidth])

    useEffect(() => {
        setXTranslation(distOffset ? -distOffset : 0);
    }, [distOffset])

    const handleModalClose = (e) => {
        if (modalRef && modalRef.current.contains(e.target)) {
            return;
        }
    }

    const addListeners = () => {
        if (isMobile) {
            window.addEventListener('touchend', handleModalClose);
        } else {
            window.addEventListener('click', handleModalClose);
        }
    }

    const removeListeners = () => {
        if (isMobile) {
            window.removeEventListener('touchend', handleModalClose);
        } else {
            window.removeEventListener('click', handleModalClose);
        }
    }

    const fetchFontStyles = () => {
        getFontStylesAsync()
            .then((fontStyles) => setFontStyles(fontStyles))
            .catch((err) => console.error(err));

    }

    const buttonClick = () => {
        window.open((hotspotId['$oid'] === '60f0d2f8c584ff71d102cc1a') ? 'https://www.fendi.com/us/info/customer-care/book-appointment/book-appointment-form?type=appointment&storeId=004001' : (hotspotId['$oid'] === '61003664d4c173fde954d61e') ? 'https://www.fendi.com/us/info/customer-care/book-appointment/book-appointment-search?type=appointment' : 'https://www.fendi.com/us/', '_blank');
    }

    const imageCarousalButton = () => {
        return (
            <div className="product-button-container"><Button
                hoverStyleChange={true}
                onClick={buttonClick}
                primaryColor='#FFB217'
                secondaryColor='#FFB217'
                className="text-marker-button flex-center obsessvr-regularFont full-width pointer product-button"
                style={{ padding: '0', margin: '0 1%', borderRadius: '4px' }}
                primaryBorderColor='white'
                secondaryBorderColor='white'
                primaryBorderWidth='0px'
                secondaryBorderWidth='0px'
                insetBorder={true}
                padded={false}
            >
            <p className='obsessvr-regularFont image-carousal-button-text' style={{fontSize: isMobile ? '14px' : '16px'}}>{['60f0d2f8c584ff71d102cc1a', '61003664d4c173fde954d61e'].includes(hotspotId['$oid']) ? 'BOOK AN APPOINTMENT' : 'DISCOVER NOW'}</p>
            </Button></div>
        )
    }

    const textItem = () => {
        const productImageStyle = { display: 'inline', minWidth: '100%', minHeight: '100%', objectFit: 'contain', transition: 'all 500ms', padding: '0', transform: `translate(${xTranslation}px, 0px)` };

        return pages.map((x, i) => {
            return (
                <div className='image-carousal-image' key={i} style={productImageStyle}>
                    <img src={constructUrl(x.image)} style={{ width: '80%' }} />
                </div>
            )
        })
    }

    const onclickHandler = (arrowType) => {
        if (arrowType == 'left-arrow') {
            setCurrentIndex(currentIndex - 1);
        } else {
            setCurrentIndex(currentIndex + 1);
        }
        CarouselArrowClicked(currentSceneName);
    }

    const textContainer = () => {
        return (
            <div className='text-modal-carousel' ref={carouselContainer} style={{ overflowY: currentIndex == 0 ? 'hidden' : 'auto' }}>
                {textItem()}
            </div>
        )
    }

    const arrowIndicatore = () => {
        return (
            <div className='text-modal-arrow'>
                {currentIndex > 0 && <div className="left-arrow" onClick={() => onclickHandler('left-arrow')}><img src={leftArrow} alt='left-arrow' /></div>}
                {totalItems > 1 && (currentIndex + 1) < totalItems && <div className="right-arrow" onClick={() => onclickHandler('right-arrow')}><img src={rightArrow} alt='right-arrow' /></div>}
            </div>
        )
    }

    const renderModalContent = () => {
        return (
            <div className='text-modal-content' style={{ textAlign: 'center' }} ref={modalRef}>
                {arrowIndicatore()}
                <div><img height="27px" src="https://cdn.obsess-vr.com/fendi/fendi_roma.svg" alt="fendi-logo" /></div>
                <div className='image-carousal-title' style={{ fontSize: '18px' }}>{pages[0].title}</div>
                <div className="image-carousal-subtitle">{pages[0].subtitle}</div>
                {textContainer()}
                <div className="image-carousal-description" style={{ fontSize: '14px' }}>{pages[0].description}</div>
                {imageCarousalButton()}
            </div>
        )
    }   

    return (
        //Added the isImage Loaded bool here to display the close button on the Modal due to a condition in Modal.jsx
        <FlyUpModal extraClassName="text-image-modal-container" onModalHidden={onModalHidden} isOpaque
            textPopup hideCloseIcon isImageLoaded closeIconImage={closeIcon}>
            <ModalOverlay />
            {!!fontStyles && renderModalContent()}
        </FlyUpModal>
    );
}

export default props => (
    <AppContext.Consumer>
        {appContextValue => (
            <ImageCarouselModal {...props} currentSceneName={appContextValue.currentSceneName} />
        )}
    </AppContext.Consumer>
);